import { EnumBookerPaymentTimingTiming, EnumProductType } from "../../../../gql/generated";

/** Placeholder payment method the server recognizes for invoiced-later bookings. */
export const AFTER_SERVICE_PAYMENT_METHOD_ID = "deferred_pending";

/**
 * "Invoice after service" widgets let eligible guests book without paying;
 * the server invoices them later. Paying an invoice is always a payment.
 */
export const isAfterServiceCheckout = ({
  timing,
  eligible,
  paymentRequestId,
  productType,
  total,
}: {
  timing?: EnumBookerPaymentTimingTiming | null;
  eligible: boolean;
  paymentRequestId?: string | null;
  productType?: EnumProductType | null;
  total: number;
}) =>
  timing === EnumBookerPaymentTimingTiming.AfterService &&
  eligible &&
  !paymentRequestId &&
  productType !== EnumProductType.RenewableFee &&
  total > 0;
